module.exports = __webpack_public_path__ + "img/emojiLostTime.b8db4a57.svg";